import { fetchUserBilling } from '@user/redux/routines';
import planReducer, { PlanState, getInitialPlanState } from './planReducer';
import cardsReducer, { CardItem, getInitialCardsState } from './cardsReducer';
import { produce } from 'immer';

import type {
  FetchUserBillingReducerAction,
  FetchUserBillingRoutine,
} from '../interfaces';

export interface BillingState {
  readonly plan: PlanState;
  readonly cards: CardItem[];
}

export const getInitialBillingState = (): BillingState => ({
  plan: getInitialPlanState(),
  cards: getInitialCardsState(),
});

export default function billingReducer(
  state = getInitialBillingState(),
  action: FetchUserBillingReducerAction
): BillingState {
  switch (action.type) {
    case fetchUserBilling.SUCCESS:
      return produce(state, (draftState) => {
        try {
          const { data } = action.payload as FetchUserBillingRoutine['success'];
          draftState.plan = planReducer(state.plan, data);
          draftState.cards = cardsReducer(state.cards, data);
        } catch (e) {
          console.error('Reducer: fetchUserBilling.SUCCESS failed', e);
        }
      });

    default:
      return state;
  }
}
